<div [class]="['v4-layout-drawer-container', pageType]">
  <div class="v4-layout-drawer-container-body py-6 overflow-y-auto">
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 8 }" *ngIf="!pageInit; else initialized"></nz-skeleton>

    <ng-template #initialized>
      <nz-table
        #nzTable
        class="v4-layout-list"
        [nzFrontPagination]="false"
        [nzData]="listOfPlan"
        [nzTotal]="total"
        [(nzPageIndex)]="page"
        [nzPageSize]="pageSize"
        nzPaginationType="small"
        [nzShowTotal]="totalTpl"
        (nzPageIndexChange)="onPageChange($event)"
      >
        <thead>
          <tr>
            <th class="w-1/3">
              {{ 'automation-overview_html_th_计划' | translate }}
              <!-- Action -->
            </th>
            <th class="w-1/3">
              {{ 'automation-overview_html_th_who' | translate }}
              <!-- who -->
            </th>
            <th class="w-1/3">
              {{ 'automation-overview_html_th_时间' | translate }}
              <!-- Time -->
            </th>
          </tr>
        </thead>
        <tbody class="v4-layout-list-body">
          <tr
            *ngFor="let row of nzTable.data"
            class="cursor-pointer"
            [ngClass]="{
              'text-c-l1': row.status === 'success' || row.status === 'failed'
            }"
            (click)="row.status === 'waiting' && onClickItem(row)"
            nz-popover
            [nzPopoverTitle]="null"
            [nzPopoverContent]="row.status === 'failed' ? ('word.fail_reason' | translate) + row.failed_reason : null"
          >
            <td>{{ row.plan_name }}</td>
            <td>{{ row.send_to }}</td>
            <td>
              <div>{{ row.plan_time }}</div>
              <div *ngIf="row.status === 'success'">({{ 'word.success' | translate }})</div>
              <div *ngIf="row.status === 'failed'" class="text-[#ff0000]">({{ 'word.fail' | translate }})</div>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #totalTpl>
        {{ 'component-page_html_总数' | translate : { number: total } }}
        <!-- {{ total }} items -->
      </ng-template>
    </ng-template>
  </div>

  <div class="v4-layout-drawer-container-footer pb-[30px] border-t border-solid border-c-gs">
    <button nz-button nzSize="large" (click)="onClose()">
      {{ 'word.close' | translate }}
      <!-- Close -->
    </button>
  </div>
</div>
